import React, { useEffect, useState } from "react";
import { Navigate } from "react-router";
import YouTube from 'react-youtube';
import CreativeNameDisplay from "../shared/CreativeNameDisplay";

function FullVideoPreview({ preview }) {
  const [show, setShow] = useState(true)
  const [playbtn, setPlaybtn] = useState(false)
  const handleClick = () => {
    let url = preview.button_link;
    if (!/^https?:\/\//i.test(url)) {
      url = `https://${url}`;
    }
    window.open(url, '_blank');
  };
  let videoId = '';
  let isEmbedded = false;
  if (preview.video_urls?.includes('embed')) {
    videoId = preview.video_urls?.split('/').pop();
    isEmbedded = true;
  }

  useEffect(() => {
    setPlaybtn(false)
  }, [preview.img_urls, preview.video_urls])
  // const showVideo = () => {
  //   setShow(!show)
  // }
  return (
    <div>
      <CreativeNameDisplay preview={preview} />
      <div className="preview-inner">
        <div className="preview-full-video flex flex-col">
          {!playbtn && preview.video_urls && (preview.img_urls === undefined || preview.img_urls === "") && <section className="flex-1" role="video">
            {preview.video_urls && (isEmbedded ? (
              <YouTube
                videoId={videoId}
                opts={{
                  height: "100%",
                  width: "100%",
                }}
              />
            ) : (
              <iframe src={preview.video_urls} style={{ width: "100%", height: "100%" }} controls referrerPolicy="no-referrer" />
            ))}
          </section>}
          {playbtn && preview.video_urls && <section className="flex-1" role="video">
            {preview.video_urls && (isEmbedded && playbtn ? (
              <YouTube
                videoId={videoId}
                opts={{
                  height: "100%",
                  width: "100%",
                }}
                onReady={(event) => {
                  event.target.playVideo();
                }}
              />
            ) : (
              <iframe src={playbtn && preview.video_urls} style={{ width: "100%", height: "100%" }} controls autoPlay referrerPolicy="no-referrer" />
            ))}
          </section>}
          {!playbtn && preview.img_urls && <section className="flex-1 relative" role="image">
            <img src={preview.img_urls} alt="" className="w-full h-full" />
            {/* PLAY BUTTON */}
            {!playbtn && preview.video_urls ?
              <div className="w-full h-full flex items-center justify-center absolute top-0 left-0 text-center text-[30px]">
                <sl-icon-button
                  library="lucide"
                  name="play-circle"
                  label="Play Video"
                  style={{ fontSize: "3rem" }}
                  className="shadow"
                  onClick={() => setPlaybtn(true)}></sl-icon-button>
              </div> : null}
            {/* END PLAY BUTTON */}
          </section>}

          {playbtn && preview.video_urls === "" && preview.img_urls && <section className="flex-1 relative" role="image">
            <img src={preview.img_urls} alt="" className="w-full h-full" />
          </section>}
          {preview.button_enabled && <div className="text-center p-2">
            {(preview.btn_text_bgclr !== "#ffffff" ? <button className="btn" style={{ backgroundColor: preview.btn_text_bgclr, color: preview.btn_text_clr, border: `1px solid ${preview.btn_text_clr} ` }} onClick={handleClick}>{preview.button_text}</button>
              : <button onClick={handleClick}>{preview.button_text}</button>)}
          </div>}
        </div>
      </div>
    </div>
  );
}

export default FullVideoPreview;
